import autoAnimate from '@formkit/auto-animate'

export default {
  inserted(el, binding) {
    autoAnimate(el)
  },
}
